import { useLayoutEffect } from 'react';
import { useLocation } from 'react-router-dom';

// Disable the browser's automatic scroll restoration once at module load
if (typeof window !== 'undefined' && 'scrollRestoration' in window.history) {
  window.history.scrollRestoration = 'manual';
}

export const ScrollToTop = () => {
  const { pathname, hash } = useLocation();

  useLayoutEffect(() => {
    // If there's a hash (like #contact), let the hash-scroll behaviour run.
    if (hash) return;

    const html = document.documentElement;
    const prevBehavior = html.style.scrollBehavior;
    // Force instant scroll (override global 'smooth' scroll-behavior)
    html.style.scrollBehavior = 'auto';

    window.scrollTo(0, 0);

    // Re-scroll after next paint to counter late-mounting content pushing layout
    const raf = requestAnimationFrame(() => {
      window.scrollTo(0, 0);
      // Restore prior smooth behaviour for hash-anchor / user smooth scrolling
      html.style.scrollBehavior = prevBehavior;
    });

    return () => {
      cancelAnimationFrame(raf);
      html.style.scrollBehavior = prevBehavior;
    };
  }, [pathname, hash]);

  return null;
};
